import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { InteracWordmark } from 'vopay';
import { Direction } from './AccountLimit';

export default function useAccountLimitLabels() {
  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.UseAccountLimitLabels' });

  function railLabel(rail: string): ReactNode {
    switch (rail) {
      case 'eft':
        return t('Rails.eft', { defaultValue: 'EFT' });
      case 'interac':
        return <InteracWordmark />;
      case 'rtr':
        return t('Rails.rtr', { defaultValue: 'Real-Time Rail (RTR)' });
      case 'credit_card':
        return t('Rails.creditCard', { defaultValue: 'Credit Card' });
      case 'push_to_card':
        return t('Rails.pushToCard', { defaultValue: 'Push to Card' });
      case 'ach':
        return t('Rails.ach', { defaultValue: 'ACH' });
      case 'rtp':
        return t('Rails.rtp', { defaultValue: 'RTP®' });
      case 'fednow':
        return t('Rails.fednow', { defaultValue: 'FedNow®' });
      case 'wire':
        return t('Rails.wire', { defaultValue: 'Wire' });
      // The API can send a rail key added after this list (Rails is keyed by string); never hide it.
      default:
        return rail.toUpperCase();
    }
  }

  function directionTitle(rail: string, direction: Direction): string {
    switch (rail) {
      case 'eft':
      case 'ach':
        return direction === 'Inbound'
          ? t('Directions.fund', { defaultValue: 'Fund' })
          : t('Directions.withdraw', { defaultValue: 'Withdraw' });
      case 'interac':
        return direction === 'Inbound'
          ? t('Directions.requestMoney', { defaultValue: 'Request Money' })
          : t('Directions.bulkPayout', { defaultValue: 'Bulk Payout' });
      case 'credit_card':
        if (direction === 'Inbound') return t('Directions.cardPayments', { defaultValue: 'Card Payments' });
        break;
      case 'rtr':
      case 'rtp':
      case 'fednow':
      case 'wire':
      case 'push_to_card':
        if (direction === 'Outbound') return t('Directions.payout', { defaultValue: 'Payout' });
        break;
    }

    return direction === 'Inbound'
      ? t('Directions.inbound', { defaultValue: 'Inbound' })
      : t('Directions.outbound', { defaultValue: 'Outbound' });
  }

  return { railLabel, directionTitle };
}
